module.exports = __webpack_public_path__ + "images/8fbd4a7d08c325385d21fb2d63571942-favicon-16x16.png";